<template>
    <v-dialog v-model="commentDialog" width="1300">
        <v-card>
            <v-card-title class="text-h5 secondary white--text lighten-2">
                    <span class="mr-1" v-if="commentType == 'header'">
                        {{ shift.shift_header.Date }}</span
                    >
                    Shift
                    <span class="ml-1 mr-1" v-if="commentType == 'shift'">
                        {{ shift.ShiftDetail }}</span
                    >
                    - Comment
            </v-card-title>

            <v-card-text class="pt-5">
                <div  v-if="commentType == 'shift'" class="mx-4 mt-4">
                    <v-row>
                        <v-col>
                            <v-row>
                                <h2>Date</h2>
                            </v-row>
                            <v-row class="mb-4 text-md-body-1">
                                {{ shift.shift_header.Date }}
                            </v-row>
                            <v-row>
                                <h2>Driver</h2>
                            </v-row>
                            <v-row class="mb-4 text-md-body-1">
                                {{ shift.driver.Name }}
                            </v-row>
                        </v-col>
                        <v-col>
                            <v-row>
                                <h2>Truck</h2>
                            </v-row>
                            <v-row class="mb-4 text-md-body-1">
                                {{ shift.truck.Truck }}
                            </v-row>
                            <v-row>
                                <h2>Trailer</h2>
                            </v-row>
                            <v-row class="mb-4 text-md-body-1">
                                {{ shift.trailer.Trailer }}
                            </v-row>
                        </v-col>
                    </v-row>
                </div>
                <v-textarea label="Comment" v-model="comment"></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="danger" @click="$emit('close')">
                    Cancel
                </v-btn>
                <v-btn color="primary" @click="saveComment()">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios';
export default {
    props:[,'shift','commentDialog','commentType'],
    data: function ()
    {
        return {
            comment:commentType == 'shift' ? this.shift.ShiftAssmtComments : this.shift.shift_header.ShiftComments,
        }
    },
    methods:{
        
        saveComment: function() {
            var params = {};

            if (this.commentType == 'header') {
                params = {
                    ShiftComments: this.comment
                };
                axios
                    .put('shift-header/' + this.header.ShiftId, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response);
                        this.shift.shift_header.ShiftComments = this.comment;
                        this.$emit('close');
                    })
                    .catch(function(error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                    });
            }

            if (this.commentType == 'shift') {
                params = {
                    ShiftAssmtComments: this.comment
                };
                axios
                    .put('shift-detail/' + this.shift.ShiftDetail, params, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    .then(async response => {
                        console.log(response);
                        this.shift.ShiftAssmtComments = this.comment;
                        this.$emit('close');
                    })
                    .catch(function(error) {
                        this.$store.state.isLoading = false;
                        console.log(error);
                    });
            }
        },
    },
    mounted(){
        console.log(this.shift);
    }
}
</script>